/**
 * Route for `dpa-template-on-request`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DpaTemplateOnRequestPage } from "../features/dpa-template-on-request/DpaTemplateOnRequestPage";

export const dpaTemplateOnRequestRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dpa-template-on-request",
	component: DpaTemplateOnRequestPage,
});

export default dpaTemplateOnRequestRoute;
